import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import http from "services/http";
import { ECode } from "ztypes/error-code";
import illusZba from "images/illus_zba.svg";
import iconCheck2 from "images/icon_check_2.svg";
import { Trans, useTranslation } from "react-i18next";
import ErrorPage from "pages/error-page";
import { error } from "console";
import { useRecoilValue } from "recoil";
import { zoomState } from "state";

interface IAppProps {}

const UpgradeZba: React.FC<IAppProps> = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const zoom = useRecoilValue(zoomState);
  const [searchParams] = useSearchParams();
  const [upgradeError, setUpgradeError] = useState<ECode>(ECode.SUCCESS);

  const upgradeZba = async () => {
    const encryptGid = searchParams.get("gid");
    const resp = await http.upgrateZba(encryptGid);
    if (resp) {
      if (resp.error_code == ECode.SUCCESS) {
        navigate(`/lp${window.location.search}`);
      } else if (resp.error_code == ECode.EXCEPTION) {
        navigate("/nf");
      } else {
        setUpgradeError(resp.error_code);
      }
    }
  };
  useEffect(() => {
    document.title = t("regis_zba.header.title");
  }, []);
  if (upgradeError != ECode.SUCCESS) {
    return <ErrorPage ecode={upgradeError} />;
  }

  return (
    <>
      <div className="pt-12 short:pt-2 pb-4 short:pb-2 px-6 h-dvh flex flex-col items-center self-stretch justify-between text-size-adjust-auto">
        <div className="flex flex-col" style={{ zoom: zoom }}>
          <div className="flex flex-col items-center self-stretch">
            <img className="w-32 h-32 short:w-32 short:h-28" src={illusZba} />
            <div className="mt-6 short:mt-3 flex flex-col items-center self-stretch ">
              <div className="text-center font-medium text-[22px] leading-[26px]">
                {t("regis_zba.header.title")}
              </div>
              <div
                className="mt-4 short:mt-2 text-center font-normal text-[15px] leading-[20px]"
                style={{ color: "#6F7071" }}
              >
                {t("regis_zba.header.sub_title")}
              </div>
            </div>
          </div>
          <div
            className="mt-8 short:mt-2 px-4 py-6 rounded-xl flex flex-col"
            style={{ background: "#F7F7F8" }}
          >
            <div
              className="font-semibold text-[15px] leading-[20px]"
              style={{ color: "#3D3D3D" }}
            >
              {t("regis_zba.benefit.title")}:
            </div>
            <div className="mt-5 flex flex-col">
              <div className="flex flex-start">
                <img className="w-4 h-4 mt-[3px]" src={iconCheck2} />
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  {t("regis_zba.benefit.community_quota")}
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <img className="w-4 h-4 mt-[3px]" src={iconCheck2} />
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  {t("regis_zba.benefit.quick_message_quota")}
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <img className="w-4 h-4 mt-[3px]" src={iconCheck2} />
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  {t("regis_zba.benefit.auto_reply_quota")}
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <img className="w-4 h-4 mt-[3px]" src={iconCheck2} />
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  {t("regis_zba.benefit.shortlink")}
                </div>
              </div>
              <div className="mt-4 flex flex-start">
                <img className="w-4 h-4 mt-[3px]" src={iconCheck2} />
                <div className="ml-3 font-normal text-[16px] leading-[22px]">
                  {t("regis_zba.benefit.catalog")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="mt-2 flex flex-col space-y-4 short:space-y-2 w-full"
          style={{ zoom: zoom }}
        >
          <div
            className="flex flex-col items-start self-stretch bg-blue-600 rounded-full"
            onClick={upgradeZba}
          >
            <div className="flex flex-col h-12 py-3 justify-center items-center self-stretch font-medium text-[15px] leading-[20px] text-white">
              {t("regis_zba.btn.title")}
            </div>
          </div>
          <p
            className="text-[14px] leading-4 text-neutral-500 text-center"
            style={{ textAlignLast: "center" }}
          >
            <Trans
              i18nKey="regis_zba.consent"
              components={{
                a: (
                  <a
                    className="text-blue-600 font-medium"
                    href="https://business.zbox.vn/service-agreement"
                  ></a>
                ),
                font500: <span className="font-medium"></span>,
              }}
            />
          </p>
        </div>
      </div>
    </>
  );
};

export default UpgradeZba;
